import { Injectable } from '@angular/core';
import { ApiService } from '../services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClaimsService {

  constructor(
    public apiService: ApiService
  ) { }

  public getAllClaims(requestParam: {}): Observable<any> {
    return this.apiService.postService('claims', requestParam);
  }

  public saveClaim(requestParam: {}): Observable<any> {
    return this.apiService.postService('claims/create', requestParam);
  }

  
  public getClaimById(requestParam: {}): Observable<any> {
    return this.apiService.postService('claims/edit',requestParam);
  }
  
  public getClaimForm(): Observable<any> {
    return this.apiService.getService('claims/form',{});
  }

  public editClaim(requestParam: {}): Observable<any> {
    return this.apiService.postService('claims/update',requestParam);
  }

  public getWorkflowOverview(requestParam: {}): Observable<any> {
    return this.apiService.postService('workflow/overview',requestParam);
  }

  public deleteClaim(requestParam: {}): Observable<any> {
    return this.apiService.postService('claims/delete',requestParam);
  }
  
  public postWorkflowActivity(requestParam: {}): Observable<any> {
    return this.apiService.postService('workflow/activity',requestParam);
  }
  
  public getWorkflowFulfill(requestParam: {}): Observable<any> {
    return this.apiService.postService('workflow/fulfill',requestParam);
  }

  public getSolicitorList(requestParam: {}): Observable<any> {
    return this.apiService.getService('claims/solicitor-list', requestParam)
  }
}
